import { splitError } from '@/helper/splitError'

/* Mit Henning abgestimmte Regeln für das Tracking
-> type validation nur bei der inline- Validierung von Formularfeldern verwenden
-> Bei normalen backend-Calls immer type 'technical'
-> Der Fehlercode wird, sofern er nicht bereits teil der message ist, an die message angehangen (Fehler: XXX)
-> der Fehlercode besteht aus CODE [- TOKEN] - bei der Einlösung von tokens im checkout wird also das eingegebene Token
   zusätzlich mit am Code getrackt
*/
const trackData = (type, data) => {
  if (typeof window.trackingNS?.track?.tracking === 'function') {
    window.trackingNS.track.tracking(type, data)
  }
}

export default {
  methods: {
    trackData,
    getErrorCode (error) {
      let errorCode = 500
      // get error code
      if (splitError(error)[0]?.extensions?.magma_code) {
        errorCode = splitError(error)[0].extensions.magma_code
      }
      return errorCode
    },
    getErrorMessage (error) {
      const errorCode = this.getErrorCode(error)
      let errorMessage = 'Es ist ein technischer Fehler aufgetreten.'
      if (splitError(error)[0]?.message) {
        errorMessage = splitError(error)[0]?.message
      }
      // add error code to error message if not already part of the message
      if (errorMessage.indexOf(errorCode) === -1) {
        errorMessage = errorMessage + ' (Fehler: ' + errorCode + ')'
      }
      return errorMessage
    },
    triggerValidationErrorTracking (field) {
      this.trackData('error', {
        type: 'validation',
        message: 'required field missing',
        location: field + ' - unknown'
      })
    },
    triggerErrorTracking (error, additionalCode = null) {
      const errorCode = this.getErrorCode(error)
      const errorMessage = this.getErrorMessage(error)
      if (errorMessage !== null) {
        this.trackData('error', {
          type: 'technical',
          message: errorMessage.substring(0, 50),
          code: String(errorCode) + (additionalCode ? ' - ' + additionalCode : '')
        })
      }
    }
  }
}
export { trackData }
